module.exports = __webpack_public_path__ + "img/2-6.f53c7249.svg";